import { defineMessages } from 'react-intl-next';

export const messages = defineMessages({
  now: {
    id: 'relative-time.now',
    defaultMessage: 'now',
    description: 'Displayed when a timestamp is very recent (within 5 seconds)',
  },
  'whiteboards.lozenge.premium': {
    id: 'whiteboards.lozenge.premium',
    defaultMessage: 'Premium',
    description: 'Text for the premium lozenge displayed in various UI components.',
  },
});
